// extracted by mini-css-extract-plugin
module.exports = {"notesWrapper":"styles-module__notesWrapper___T8o9e","noteTimestamp":"styles-module__noteTimestamp___1CAap"};